// store.js

import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './_store/auth.module'
import { flashMessage } from './_store/flash.module'
import { subMenus } from './_store/menu.module'
import { setting } from './_store/setting.module'
import { settingWizardStore } from './_store/setting-wizard.module'
import { useCaseSelection } from './_store/use-case-selection.module'
import { socket } from './_store/socket.module'
import { dashboard } from './_store/dashboard.module'
import { checkPassword } from './_store/check.module'
import { devSettingStore } from './_store/dev-setting.module'
import AppConstants from './constants/app.constants'

Vue.use(Vuex)

const getMstTableFromStorage = () => {
  const mstTableLocalStorage = JSON.parse(localStorage.getItem('mstTable'))
  if (!mstTableLocalStorage) {
    return []
  }
  return mstTableLocalStorage
}
const setMstTableFromStorage = mstTable => {
  localStorage.setItem('mstTable', JSON.stringify(mstTable))
}

const getWorkModeStorage = () => {
  const workMode = parseInt(localStorage.getItem('workMode'))
  return workMode || 1
}

const getReopenChuteGridWindowFlagFromStorage = () => {
  const reopenChuteGridWindowFlag = parseInt(sessionStorage.getItem(AppConstants.STORAGE_REOPEN_CHUTE_GRID_WINDOW))
  return reopenChuteGridWindowFlag | 0
}

const addTableToState = (state, table) => {
  // Find old table in memory
  const oldMstTableIndex = state.mstTable.findIndex(
    tableToFind =>
      table.tableManagementSerialId === tableToFind.tableManagementSerialId
  )
  if (oldMstTableIndex === -1) {
    pushTableToState(state, table)
  } else {
    const oldMstTable = state.mstTable[oldMstTableIndex]
    state.mstTable[oldMstTableIndex] = {...table}
    state.mstTable[oldMstTableIndex].itemOrder = oldMstTable.itemOrder
    sortStateTableList(state.mstTable)
  }

  setMstTableFromStorage(state.mstTable)
}

const pushTableToState = (state, table) => {
  sortStateTableList(state.mstTable)
  const foundDuplicateItemOrderTableIndex = state.mstTable.findIndex(
    tableToFind => tableToFind.itemOrder === table.itemOrder
  )
  if (
    foundDuplicateItemOrderTableIndex !== -1 &&
    foundDuplicateItemOrderTableIndex !== state.mstTable.length - 1
  ) {
    state.mstTable
      .filter(
        tableToIncrease =>
          tableToIncrease &&
          tableToIncrease.itemOrder !== undefined &&
          tableToIncrease.itemOrder !== null &&
          tableToIncrease.tableNo === table.tableNo &&
          tableToIncrease.itemOrder > table.itemOrder
      )
      .map(tableToIncrease => tableToIncrease.itemOrder++)
    table.itemOrder++
  }

  state.mstTable.push(table)
  sortStateTableList(state.mstTable)
}

const sortStateTableList = tableList => {
  tableList.sort(
    (firstTable, secondTable) => firstTable.itemOrder - secondTable.itemOrder
  )
}
export const store = new Vuex.Store({
  modules: {
    auth,
    flashMessage,
    subMenus,
    setting,
    socket,
    checkPassword,
    dashboard,
    settingWizardStore,
    devSettingStore,
    useCaseSelection
  },
  state: {
    mstTable: getMstTableFromStorage(),
    menuActiveClass: '',
    modalMode: false,
    workMode: getWorkModeStorage(),
    importMode: false,
    windowInstance: {},
    reopenChuteGridWindowFlag: getReopenChuteGridWindowFlagFromStorage(),
    closeIconErrMsg: true,
    reconnectedFlag: true,
    isUploading: false,
    isLoadingLogoutEntra: false
  },
  mutations: {
    setMstTable(state, { tableList, tableNo }) {
      // Find if a table column is deleted in database
      for (let index = 0; index < state.mstTable.length; index++) {
        const tableInMemory = state.mstTable[index]
        const foundInDatabaseIndex = tableList.findIndex(
          columnInMemory =>
            columnInMemory.tableManagementSerialId ===
            tableInMemory.tableManagementSerialId
        )
        if (foundInDatabaseIndex !== -1 || tableInMemory.tableNo !== tableNo) {
          continue
        }

        state.mstTable.splice(index, 1)
        index--
      }
      for (const table of tableList) {
        addTableToState(state, table)
      }
    },

    updateTableInState(state, changedMstTable) {
      // Find old table in memory
      const oldMstTableIndex = state.mstTable.findIndex(
        tableToFind =>
          changedMstTable.tableManagementSerialId === tableToFind.tableManagementSerialId
      )
      if (oldMstTableIndex !== -1) {
        state.mstTable[oldMstTableIndex] = {...changedMstTable}
      }

      setMstTableFromStorage(state.mstTable)
    },

    addTableToStateNotEditOrder(state, table) {
      addTableToState(state, table)
    },

    addMenuActive(state, routeName) {
      state.menuActiveClass = routeName
    },
    setModalMode(state, value) {
      state.modalMode = value
    },
    setWorkMode(_state, value) {
      localStorage.setItem('workMode', value)
      _state.workMode = value
    },
    setImportMode(state, value) {
      state.importMode = value
    },
    setWindowInstance(state, value) {
      state.windowInstance = value
    },
    setReopenChuteGridWindowFlag(state, value) {
      sessionStorage.setItem(AppConstants.STORAGE_REOPEN_CHUTE_GRID_WINDOW, value)
      state.reopenChuteGridWindowFlag = value
    },
    setCloseIconErrMsgMode(state, value) {
      state.closeIconErrMsg = value
    },
    setReconnectedFlag(state, value) {
      state.reconnectedFlag = value
    },
    setIsUploading(state, value) {
      state.isUploading = value
    },
    setIsLoadingLogoutEntra(state, value) {
      state.isLoadingLogoutEntra = value
    }
  },
  getters: {
    getMstTable: state => (tableNo, excludeNonDisplayedItem = true) => {
      sortStateTableList(state.mstTable)
      const filteredTable = state.mstTable.filter(
        table => {
          if (!excludeNonDisplayedItem) {
            return table.tableNo === tableNo
          }
          return table.displayFlag && table.tableNo === tableNo
        }
      )
      return filteredTable
    },
    getMenuActive: state => {
      return state.menuActiveClass
    },
    getModalMode: state => {
      return state.modalMode
    },
    getWorkMode: state => {
      return state.workMode
    },
    getImportMode: state => {
      return state.importMode
    },
    getWindowInstance: state => {
      return state.windowInstance
    },
    getReopenChuteGridWindowFlag: state => {
      return state.reopenChuteGridWindowFlag
    },
    getCloseIconErrMsgMode: state => {
      return state.closeIconErrMsg
    },
    getReconnectedFlag: state => {
      return state.reconnectedFlag
    },
    getIsUploading: state => {
      return state.isUploading
    },
    getIsLoadingLogoutEntra: state => {
      return state.isLoadingLogoutEntra
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js